import { cn } from '@/lib/utils';

const ColumnLayouts = {
  two: 'sm:grid-cols-2',
  four: 'sm:grid-cols-2 lg:grid-cols-4',
};

export function RuledList({ items, columns = 'two' }) {
  return (
    <ul className={cn('mt-12 grid gap-x-8 lg:gap-x-10', ColumnLayouts[columns])}>
      {items.map((item) => (
        <li key={item.title} className="border-t border-grid pb-8 pt-6 sm:pb-10">
          <h3 className="text-lg font-bold text-graphite">{item.title}</h3>
          <p className="mt-2 max-w-[48ch] leading-relaxed text-steel">{item.description}</p>
          {item.tag ? (
            <p className="mt-4 inline-flex rounded-sm bg-pad-light px-2 py-0.5 text-sm font-semibold text-graphite">{item.tag}</p>
          ) : null}
        </li>
      ))}
    </ul>
  );
}